howspace.commentsTrait = (() => {
    'use strict';

    // Lightweight generic comment views created handler.
    real.onTierReady(real.TIER_2, () => {
        real.events.on('comment:views:created', notification => {
            notification.object.comments.forEach(commentId => {
                const comments = $('article[data-id="' + commentId + '"]');
                comments.each(function () {
                    updateViews(notification, $(this));
                });
            });
        });
    });

    // One centralized resize observer for all assignment and chat widgets.
    const resizeObserver = new ResizeObserver(entries => {
        entries.forEach((entry) => {
            const widget = $(entry.target);
            if (widget.data('latest-width') === entry.contentRect.width) {
                // Width not changed.
                return;
            }
            widget.data('latest-width', entry.contentRect.width);
            if (widget.data('clamp-comment-text-timeout-id')) {
                clearTimeout(widget.data('clamp-comment-text-timeout-id'));
            }
            widget.data('clamp-comment-text-timeout-id', setTimeout(() => {
                howspace.commentsTrait.clampCommentText(widget);
            }, 100));
        });
    });

    const checkPromptBtn = (widget) => {
        const promptWidgetBtn = widget.find('.prompt-widget-btn');
        const promptBtn = widget.find('.prompt-btn');
        if (promptWidgetBtn.length === 0 || promptBtn.length === 0) {
            return;
        }

        if (widget.data('number-of-comments') > 0) {
            promptWidgetBtn.removeClass('disabled');
            promptBtn.removeClass('disabled');
            howspace.components.toolTip.disable(promptWidgetBtn);
            howspace.components.toolTip.disable(promptBtn);
        } else {
            promptWidgetBtn.addClass('disabled');
            promptBtn.addClass('disabled');
            howspace.components.toolTip.enable(promptWidgetBtn);
            howspace.components.toolTip.enable(promptBtn);
            promptWidgetBtn.dataAndAttr('title', howspace.translate('discussion_prompt_disabled_tooltip'));
        }
    };

    const initFileUploaderModal = (modal, modalOpener) => {
        modal.addEventListener(howspace.components.fileUploader.UPLOAD_COMPLETED, e => {
            howspace.commentsTrait.attachmentHandlers.handleFileUploadCompleted(modal, modalOpener, e.detail.uploadedFiles);
        });
    };

    const updateCountOnButton = (btn, diff, hideOnZeroCount = true, initialCount = 0) => {
        const count = btn.data('count') + diff;
        btn.dataAndAttr('count', count);
        if (btn.hasClass('show-votes-btn')) {
            btn.text(howspace.translate('discussion_point_vote_results', { count: count }));
        }

        if (hideOnZeroCount) {
            if ((count > initialCount) && !btn.is(':visible')) {
                btn.removeClass('d-none');
            } else if (count === initialCount && btn.is(':visible')) {
                btn.addClass('d-none');
            }
        }
    };

    const updateLikes = (notification, object, diff = 1) => {
        let container = null;
        if (object.is('.comment')) {
            container = object.find('.comment-content').first();
        } else if (object.is('.reply')) {
            container = object.find('.reply-content').first();
        }

        if (!container) {
            return;
        }

        if (real.events.isFromCurrentUser(notification)) {
            container.find('.like-btn').each(function () {
                const likeBtn = $(this);
                if (diff > 0) {
                    likeBtn.dataAndAttr('like-id', notification.object.like.id);
                } else {
                    likeBtn.removeDataAndAttr('like-id');
                }
            });
        }

        const btn = object.find('.show-likes-btn').first();
        updateCountOnButton(btn, diff);
    };

    const updateViews = (notification, object, diff = 1) => {
        const btn = object.find('.show-views-btn').first();
        updateCountOnButton(btn, diff, true, 1);
    };

    const updateFlags = (notification, object, diff = 1) => {
        if (real.events.isFromCurrentUser(notification) && (diff > 0)) {
            const flagBtn = object.find('.flag-btn').first();
            flagBtn.dataAndAttr('flag-id', notification.object.flag.id);
        }

        const btn = object.find('.show-flags-btn').first();
        updateCountOnButton(btn, diff);
    };

    const updateScore = (object, diff) => {
        const btn = object.find('.show-votes-btn').first();
        updateCountOnButton(btn, diff, false);
    };

    const updateEmojiButton = (button, emojiArray, count, reactionId, isCurrentUser, isDecrease = false, reactedUsers = []) => {
        const widget = button.closest('.widget');
        button.dataAndAttr('emoji-count', count);
        button.dataAndAttr('emoji', emojiArray.join(','));
        button.find('.btn-text').text(`${emojiArray.join(' ')} ${count}`);

        if (isCurrentUser) {
            if (isDecrease) {
                button.removeDataAndAttr('reaction-id');
                button.removeDataAndAttr('included-current-user');
            } else {
                button.dataAndAttr('reaction-id', reactionId);
                button.dataAndAttr('included-current-user', true);
            }
        }

        if (reactedUsers.length > 0 && !widget.data('is-permanently-anonymous')) {
            button.dataAndAttr('user-reacted-list', reactedUsers.join(','));
            button.dataAndAttr('title', `${reactedUsers.join(', ')} ${howspace.translate('discussion_reacted_with', { emoji: button.data('emoji') })}`);
        }
    };

    const updateReactions = (notification, object, diff = 1) => {
        const commentId = notification.object?.comment?.id;
        const replyId = notification.object?.reply?.id;
        const reaction = notification.object?.reaction;

        if (!reaction) {
            return;
        }

        let widget = null;
        let reactionParentId = null;
        if (commentId) {
            const commentReactionWrapper = object.find(`#comment-${commentId}-reactions`);
            widget = commentReactionWrapper.closest('.widget');
            reactionParentId = commentReactionWrapper.closest('.comment-buttons').data('parent-id');
        } else if (replyId) {
            const replyReactionWrapper = object.find(`#reply-${replyId}-reactions`);
            widget = replyReactionWrapper.closest('.widget');
            reactionParentId = replyReactionWrapper.closest('.comment-buttons').data('parent-id');
        }

        if (!reactionParentId || !widget) {
            return;
        }

        const reactionContainer = widget.find('.comment-buttons[data-parent-id="' + reactionParentId + '"]');
        const { id: reactionId, emoji_id: emojiId, emoji, users } = reaction;
        const isCurrentUser = real.events.isFromCurrentUser(notification);
        let emojiPickerWrapper = reactionContainer.find('.reaction-btn.howspace-emoji-picker');
        let emojiButton = reactionContainer.find(`.emoji-button[data-emoji-id="${emojiId}"]`);
        let emojiCount = 0;
        let reactedUsers = []; // Right now, this contains the names of the users who reacted to the comment.
        if (users?.reactedUsers) {
            reactedUsers = users.reactedUsers.map(user => {
            if (user.is_anonymous) {
                return howspace.translate('common_someone');
            }
            if (user.id === real.dom.$body.data('user-id')) {
                return howspace.translate('common_you');
            }
            return user.name;
            });
        }

        let emojiArray = [];
        if (users?.reactedEmojis) {
            emojiArray = users?.reactedEmojis;
        }
        if (emojiButton.length > 0) {
            emojiCount = emojiButton.data('emoji-count');
        }

        emojiCount += diff; // The value of diff can be negative or positive.

        if (diff > 0) {
            if (emojiButton.length === 0) {
                const reactedWithText = howspace.translate('discussion_reacted_with', { emoji: emoji });
                const tooltipText = `${reactedUsers.join(', ')} ${reactedWithText}`;

                const emojiObj = {
                    emoji: emojiArray.join(','),
                    emoji_id: emojiId,
                    reaction_id: isCurrentUser ? reactionId : '',
                    emoji_count: emojiCount,
                    included_current_user: isCurrentUser,
                    tooltip_text: tooltipText,
                    user_reacted_list: reactedUsers.join(','),
                };

                const emojiBtnHtml = howspace.template.getHtml(widget.find('.emoji-picker-button-template'), emojiObj);
                emojiPickerWrapper.before(emojiBtnHtml);
            } else {
                updateEmojiButton(emojiButton, emojiArray, emojiCount, reactionId, isCurrentUser, false, reactedUsers)
            }
        } else if (diff < 0) {
            if (emojiCount > 0) {
                updateEmojiButton(emojiButton, emojiArray, emojiCount, null, isCurrentUser, true, reactedUsers);
            } else {
                emojiButton.remove();
            }
        }
    };

    const getCommentOrReplyUrl = (btn, isGetApiUrl = true) => {
        const widget = btn.closest('.widget');
        const comment = btn.closest('.comment');
        const reply = btn.closest('.reply');

        let url = howspace.widgets.getApiUrl(widget);
        if (!isGetApiUrl) {
            url = howspace.widgets.getUrl(widget);
        }
        url += '/comment/' + comment.data('id');
        if (reply.length > 0) {
            url += '/reply/' + reply.data('id');
        }
        return url;
    };

    const onCommentEvent = (widgetType, action, fn) => {
        howspace.widgets.onEvent(widgetType + ':comment:' + action, (widget, notification) => {
            const comment = widget.find('.comment[data-id="' + notification.object.comment.id + '"]');
            if (comment.length > 0) {
                fn(notification, comment);
            }
        });
    };

    const onReplyEvent = (widgetType, action, fn) => {
        howspace.widgets.onEvent(widgetType + ':comment:reply:' + action, (widget, notification) => {
            const reply = widget.find('.reply[data-id="' + notification.object.reply.id + '"]');
            if (reply.length > 0) {
                fn(notification, reply);
            }
        });
    };

    const updateReplyCount = (comment) => {
        comment.find('.reply-btn').dataAndAttr('count', comment.find('.replies .reply').length || '');
        if (!comment.is('.sticky-note')) {
            const showMoreRepliesBtn = comment.find('.show-more-replies-btn');
            const hiddenRepliesCount = comment.find('.reply.d-none').length;
            showMoreRepliesBtn.find('.btn-text').dataAndAttr('count', hiddenRepliesCount);
        }
    }

    const syncDirBtn = container => {
        const editorWrapper = container.find('.howspace-simple-text-editor-wrapper');
        const btn = container.find('.dir-btn');
        if (!btn.length || !editorWrapper.length) return;
        const isRtl = editorWrapper.attr('dir') === 'rtl';
        btn.toggleClass('is-rtl', isRtl).attr('aria-pressed', String(isRtl));
    };

    const getParent = e => {
        const btn = $(e.target);
        const comment = btn.closest('.comment');
        const reply = btn.closest('.reply');
        let parent;

        if (reply.length > 0) {
            parent = reply;
        } else if (comment.length > 0) {
            parent = comment;
        }

        return parent;
    }

    const handleUploadedFileInEditor = (e, widget, evtType) => {
        const editor = $(e.target);
        let containerInput;
        if (editor.closest('.comment-input').length > 0) {
            containerInput = editor.closest('.comment-input');
        } else if (editor.closest('.reply-input').length > 0) {
            containerInput = editor.closest('.reply-input');
        }

        const items = evtType === 'paste' ? e.originalEvent.clipboardData.items : e.originalEvent.dataTransfer.files;

        for (const item of items) {
            if (evtType === 'paste' && item.kind !== 'file') {
                continue;
            }
            // Show the progress bar for the upload process.
            containerInput.find('.upload-progress').removeClass('d-none');
            howspace.components.progress.update(containerInput.find('.upload-progress'), 25);

            const formData = new FormData();
            const token = real.uid();
            const file = evtType === 'paste' ? item.getAsFile() : item;

            formData.append('upload_process_metadata', JSON.stringify({
                token: token
            }));
            formData.append('file', file);

            widget.dataAndAttr('attachment-upload-token', token);
            widget.data('opener', editor);

            real.ajax(real.baseUri + '/api/uploadedfiles', {
                type: 'POST',
                data: formData,
                dataType: 'json',
                contentType: false,
                processData: false,
                success: () => {
                    howspace.components.progress.update(containerInput.find('.upload-progress'), 50);
                }
            });
        }
    };

    const handleTyping = (editor) => {
        if (!editor.data('send-is-typing')) {
            // Comment editor is not configured to send typing information.
            return;
        }

        if (!howspace.components.simpleTextEditor.hasContent(editor)) {
            // No content, do not send typing information.
            return;
        }

        let timestamp = editor.data('latest-typing-timestamp');
        if (!timestamp || Date.now() - timestamp > 4000) {
            timestamp = Date.now();
            editor.data('latest-typing-timestamp', timestamp);

            const discussionId = editor.closest('.widget-discussion').data('widget-id');
            const commentId = editor.closest('.comment').data('id') ?? null;
            // Anonymous and hidden-author discussions still send typing information (so facilitators
            // can see activity), but flagged so the relay broadcasts it without the typer's identity.
            const anonymous = editor.data('typing-anonymous') === true;
            real.realtime.getActiveConnection()?.typing(discussionId, commentId, anonymous);
        }
    };

    const handleDeletingReaction = (btn) => {
        btn.prop('disabled', true);

        if (!btn.data('reaction-id')) {
            return;
        }

        const url = getCommentOrReplyUrl(btn);

        real.ajax.json(url + '/reaction/' + btn.data('reaction-id'), {
            type: 'DELETE',
            success: (e) => {
                btn.prop('disabled', false);
            }
        });
    }

    const handleCreatingReaction = (btn, emoji) => {
        let url = getCommentOrReplyUrl(btn);

        const dataPayload = {
            emoji_id: emoji.id,
            emoji: emoji.native,
        };

        real.ajax.json(`${url}/reactions`, {
            type: 'POST',
            data: JSON.stringify(dataPayload),
            success: () => {
                // Websocket event will update the reaction button.
            }
        });
    }

    const setUncategorizedCommentsCollapsed = (category, isCollapsed) => {
        if (category.length === 0) {
            return;
        }

        const showBtn = category.find('.show-uncategorized-btn');
        const hideBtn = category.find('.hide-uncategorized-btn');
        const focusedElement = document.activeElement;
        const focusWasOnShowBtn = showBtn[0] === focusedElement;
        const focusWasInsideCategory = category[0].contains(focusedElement);
        const wasCollapsed = category.hasClass('collapsed');

        category.toggleClass('collapsed', isCollapsed);
        showBtn.add(hideBtn).attr('aria-expanded', isCollapsed ? 'false' : 'true');

        if (wasCollapsed === isCollapsed) {
            return;
        }

        if (isCollapsed && focusWasInsideCategory) {
            showBtn.trigger('focus');
        } else if (!isCollapsed && focusWasOnShowBtn) {
            hideBtn.trigger('focus');
        }
    };

    const attachComponentHandlers = widget => {
        howspace.commentsTrait.moveComment.init(widget);

        // Record audio button.
        widget.on('click', '.record-audio-btn', e => {
            howspace.commentsTrait.attachmentHandlers.countDownAndStartRecording(widget, 'audio', e.target);
        });

        // Record video button.
        widget.on('click', '.record-video-btn', e => {
            howspace.commentsTrait.attachmentHandlers.countDownAndStartRecording(widget, 'video', e.target);
        });

        widget.on('click', '.cancel-recording-btn', () => {
            howspace.commentsTrait.attachmentHandlers.cancelRecording(widget)
        });

        widget.on('click', '.upload-recording-btn', () => {
            howspace.commentsTrait.attachmentHandlers.uploadRecording(widget);
        });

        widget.on('click', '.rotate-attachment-btn', (e) => {
            const btn = $(e.target);
            const attachment = btn.closest('.attachment');
            if (attachment.length === 0) {
                return;
            }
            howspace.commentsTrait.attachmentHandlers.rotateAttachment(e.target, attachment, btn.data('angle'));
        });

        widget.on('click', '.category-btn:not(.selected)', (e) => {
            const btn = $(e.target);
            const category = btn.data('category-id') || null;

            const url = getCommentOrReplyUrl(btn);
            const dataPayload = {
                _action: 'categorize',
                category_id: category,
                order: 1,
            };

            real.ajax.json(url, {
                type: 'POST',
                data: JSON.stringify(dataPayload),
                error: () => {
                    real.button.reset(btn, editor);
                }
            });
        });

        // Enable save comment button if simple text editor has content.
        const editor = widget.find('.howspace-simple-text-editor.comment-text');
        if (editor.length > 0) {
            if (howspace.components.simpleTextEditor.hasContent(editor)) {
                editor.closest('.comment-input').find('.send-btn').prop('disabled', false);
            }
        }

        checkPromptBtn(widget);

        widget.on(howspace.components.lister.LIST_ITEMS_LOADED, () => {
            if (!widget.hasClass('observing-resize')) {
                widget.data('latest-width', widget.width());
                resizeObserver.observe(widget[0]);
            }

            // Enable save reply button if simple text editors have content.
            widget.find('.howspace-simple-text-editor.reply-text').each(function () {
                const editor = $(this);
                if (howspace.components.simpleTextEditor.hasContent(editor)) {
                    const replyInput = editor.closest('.reply-input');
                    const buttons = replyInput.find('.buttons');
                    if (!buttons.is(':visible')) {
                        howspace.animate(buttons, 'slideDown', howspace.getAnimationDuration(widget, '--howspace-animation-350'));
                    }
                    buttons.find('.send-reply-btn').prop('disabled', false);
                }
            });

            // Init transcript after the lister has loaded.
            howspace.transcript.init(widget);

            // Handle the logic for showing hide/show replies.
            widget.find('.comments .comment').each(function () {
                const comment = $(this);
                const replies = comment.find('.replies .reply');
                if (replies.length === 0) {
                    return;
                }
                let visibleReplies = [];
                let hiddenReplies = [];
                let encounteredWhatsnewDecoratedReply = false;

                if (replies.length > 2) {
                    replies.each(function () {
                        const reply = $(this);
                        if ($(reply).is('.whatsnew-decorated')) {
                            encounteredWhatsnewDecoratedReply = true;
                        }
                        if (encounteredWhatsnewDecoratedReply) {
                            visibleReplies.push(reply);
                        } else {
                            hiddenReplies.push(reply);
                        }
                    });

                    if (hiddenReplies.length <= 3) {
                        visibleReplies = hiddenReplies.concat(visibleReplies);
                        hiddenReplies = [];
                    }

                    if (visibleReplies.length < 2) {
                        visibleReplies = hiddenReplies.splice(hiddenReplies.length - (2 - visibleReplies.length));
                    }

                    if (hiddenReplies.length > 1) {
                        comment.find('.comment-hidden-replies-wrapper').removeClass('d-none');
                        comment.find('.show-more-replies-btn .btn-text').dataAndAttr('count', hiddenReplies.length);
                        hiddenReplies.forEach(function (reply) {
                            $(reply).addClass('d-none');
                        });
                    }
                }
            });

            howspace.whatsNew.decorateWidget(widget);
            howspace.commentsTrait.commentsViewHandler.observeViews(widget);
        });

        // Re-clamp comment text again once items have been rendered to fix some edge case rendering issues.
        widget.on(howspace.components.lister.LIST_ITEMS_RENDERED, () => {
            howspace.commentsTrait.clampCommentText(widget);
        });

        // Enable or disable send comment button based on content.
        widget.on(howspace.components.simpleTextEditor.CONTENT_CHANGED, '.howspace-simple-text-editor.comment-text', e => {
            const editor = $(e.target);
            const commentInput = editor.closest('.comment-input');
            const hasAttachments = commentInput.find('.attachments .attachment').length > 0;
            const hasText = !e.originalEvent.detail.isEmpty;
            commentInput.find('.send-action-btn').prop('disabled', !hasAttachments && !hasText);
            handleTyping(editor);
        });

        // Enable or disable send reply button based on content.
        widget.on(howspace.components.simpleTextEditor.CONTENT_CHANGED, '.howspace-simple-text-editor.reply-text', e => {
            const editor = $(e.target);
            const replyInput = editor.closest('.reply-input');
            const hasAttachments = replyInput.find('.attachments .attachment').length > 0;
            const hasText = !e.originalEvent.detail.isEmpty;
            replyInput.find('.send-action-btn').prop('disabled', !hasAttachments && !hasText);
            handleTyping(editor);
        });

        // Show reply buttons on focus (if buttons are hidden).
        widget.on('focus', '.howspace-simple-text-editor.reply-text', e => {
            const editor = $(e.target);
            const replyInput = editor.closest('.reply-input');
            const buttons = replyInput.find('.buttons');
            if (!buttons.is(':visible')) {
                howspace.animate(buttons, 'slideDown', howspace.getAnimationDuration(widget, '--howspace-animation-350'));
            }
        });

        widget.on('click', '.dir-btn', e => {
            const btn = $(e.currentTarget);
            const container = btn.closest('.reply-input, .comment-input');
            let editor = container.find('.howspace-simple-text-editor-wrapper');
            let dir = editor.attr('dir');
            dir = dir === 'rtl' ? 'ltr' : 'rtl';
            editor.attr('dir', dir).focus();
            container.find('input[name="text_direction"]').val(dir);
            btn.toggleClass('is-rtl', dir === 'rtl').attr('aria-pressed', String(dir === 'rtl'));
        });

        widget.on('keydown', '.howspace-simple-text-editor.comment-text, .howspace-simple-text-editor.reply-text', e => {
            let input = null;
            if ($(e.target).closest('.comment-input').length > 0) {
                input = $(e.target).closest('.comment-input');
            } else if ($(e.target).closest('.reply-input').length > 0) {
                input = $(e.target).closest('.reply-input');
            }

            let btn = null;
            if (input.find('.send-btn').length > 0) {
                btn = input.find('.send-btn');
            } else if (input.find('.save-btn').length > 0) {
                btn = input.find('.save-btn');
            } else if (input.find('.send-reply-btn').length > 0) {
                btn = input.find('.send-reply-btn');
            }

            if (btn !== null && e.keyCode === 13 && e.ctrlKey) {
                btn.trigger('click');
            }
        });

        // Send comment button.
        widget.on('click', '.send-btn', e => {
            const btn = $(e.target);

            if (btn.is('.saving, .disabled, [disabled]')) {
                return;
            }

            const commentInput = btn.closest('.comment-input');
            const editor = commentInput.find('.howspace-simple-text-editor');
            const attachments = commentInput.find('.attachments');

            real.button.loading(btn, editor);

            const dataPayload = real.form.getDataPayload(commentInput);
            if (dataPayload.text === '' && dataPayload.attachments.length === 0) {
                return;
            }

            btn.addClass('saving');

            if (howspace.widgets.getType(widget) === 'discussion') {
                dataPayload.is_ai_assisted = commentInput.find('.badge-ai-assisted').is(':visible');
            }

            real.ajax.json(howspace.widgets.getApiUrl(widget) + '/comments', {
                type: 'POST',
                data: JSON.stringify(dataPayload),
                success: () => {
                    real.button.reset(btn, editor);
                    btn.prop('disabled', true).removeClass('saving');
                    if (editor.length > 0) {
                        howspace.components.simpleTextEditor.clear(editor);
                    }
                    attachments.find('.attachment').remove();
                    attachments.addClass('d-none');
                    commentInput.find('.badge-ai-assisted').addClass('d-none');
                },
                error: () => {
                    real.button.reset(btn, editor);
                }
            });
        });

        // Delete attachment button.
        widget.on('click', '.delete-attachment-btn', e => {
            const btn = $(e.target);
            const attachments = btn.closest('.attachments');
            const commentInput = btn.closest('.comment-input');
            const replyInput = btn.closest('.reply-input');
            btn.closest('.attachment').remove();

            let editor;
            let sendButton;
            if (commentInput.length > 0) {
                editor = commentInput.find('.howspace-simple-text-editor');
                sendButton = commentInput.find('.send-action-btn');
            } else if (replyInput.length > 0) {
                editor = replyInput.find('.howspace-simple-text-editor');
                sendButton = replyInput.find('.send-action-btn');
            }

            const hasAttachments = attachments.find('.attachment').length > 0;
            if (!hasAttachments) {
                if (!howspace.components.simpleTextEditor.hasContent(editor)) {
                    sendButton.prop('disabled', true);
                }
                attachments.addClass('d-none');
            } else {
                sendButton.prop('disabled', false);
            }
        });

        // Reply button.
        widget.on('click', '.reply-btn', e => {
            const btn = $(e.target);
            const comment = btn.closest('.comment');
            const replies = comment.find('.replies');
            const replyInput = replies.find('.reply-input');
            const buttons = replyInput.find('.buttons');
            const editor = replyInput.find('.howspace-simple-text-editor');

            if (!replyInput.is(':visible')) {
                replies.removeClass('d-none');
                howspace.animate(replyInput, 'slideDown', howspace.getAnimationDuration(widget, '--howspace-animation-350'), () => {
                    replyInput.removeClass('d-none');
                    real.input.focus(editor);
                })
            } else {
                real.input.focus(editor);
            }

            // In case of sticky notes, the replies are hidden by default.
            // so the calculation of the lineCount of each comment-text is not accurate.
            // Therefore, we need to clamp the text of the comment-text of the sticky notes.
            // when the reply button is clicked.
            if (widget.data('is-sticky-notes')) {
                howspace.commentsTrait.clampCommentText(widget, replies);
            }

            // If the editor is not visible, then show the buttons.
            if (editor.length === 0 && !buttons.is(':visible')) {
                howspace.animate(buttons, 'slideDown', howspace.getAnimationDuration(widget, '--howspace-animation-350'));
            }
        });

        // Cancel reply button.
        widget.on('click', '.cancel-reply-btn', e => {
            const btn = $(e.target);
            const replyInput = btn.closest('.reply-input');
            const replies = replyInput.closest('.replies');
            const editor = replyInput.find('.howspace-simple-text-editor');
            const buttons = replyInput.find('.buttons');

            if (editor.length > 0) {
                howspace.components.simpleTextEditor.clear(editor);
            }

            buttons.find('.send-reply-btn').prop('disabled', true);

            howspace.animate(buttons, 'slideUp', howspace.getAnimationDuration(widget, '--howspace-animation-350'), () => {
                buttons.addClass('d-none');
                if (editor.length === 0) {
                    replies.addClass('d-none');
                }
            });
        });

        // Send reply button.
        widget.on('click', '.send-reply-btn', e => {
            const btn = $(e.target);
            const comment = btn.closest('.comment');
            const replyInput = btn.closest('.reply-input');
            const editor = replyInput.find('.howspace-simple-text-editor');
            const attachments = replyInput.find('.attachments');
            const dataPayload = real.form.getDataPayload(replyInput);

            btn.prop('disabled', true);

            real.ajax.json(howspace.widgets.getApiUrl(widget) + '/comment/' + comment.data('id') + '/replies', {
                type: 'POST',
                data: JSON.stringify(dataPayload),
                success: () => {
                    if (editor.length > 0) {
                        howspace.components.simpleTextEditor.clear(editor);
                    }
                    attachments.find('.attachment').remove();
                    attachments.addClass('d-none');
                }
            });
        });

        // Approve button.
        widget.on('click', '.approve-btn', e => {
            const btn = $(e.target);
            btn.prop('disabled', true);

            const url = getCommentOrReplyUrl(btn);
            const dataPayload = {
                is_approved: true
            };

            real.ajax.json(url, {
                type: 'POST',
                data: JSON.stringify(dataPayload),
                complete: () => {
                    btn.prop('disabled', false);
                }
            });
        });

        // Like button.
        widget.on('click', '.like-btn', e => {
            const btn = $(e.target);
            btn.prop('disabled', true);

            const url = getCommentOrReplyUrl(btn);

            if (btn.data('like-id')) {
                real.ajax.json(url + '/like/' + btn.data('like-id'), {
                    type: 'DELETE',
                    complete: () => {
                        btn.removeDataAndAttr('like-id');
                        btn.prop('disabled', false);
                        btn[0].focus();
                    }
                });
            } else {
                real.ajax.json(url + '/likes', {
                    type: 'POST',
                    complete: () => {
                        btn.prop('disabled', false);
                        btn[0].focus();
                    }
                });
            }
        });

        // Flag button.
        widget.on('click', '.flag-btn', e => {
            const btn = $(e.target);
            btn.prop('disabled', true);

            let ownFlagBtn = btn.closest('.reply').find('.own-flag-btn');
            if (ownFlagBtn.length === 0) {
                ownFlagBtn = btn.closest('.comment').find('.own-flag-btn').first();
            }

            const url = getCommentOrReplyUrl(btn);

            if (btn.data('flag-id')) {
                real.ajax.json(url + '/flag/' + btn.data('flag-id'), {
                    type: 'DELETE',
                    complete: () => {
                        btn.html(btn.html().replace(btn.data('text-unflag'), btn.data('text-flag')));
                        btn.removeDataAndAttr('flag-id');
                        btn.prop('disabled', false);
                        ownFlagBtn.addClass('d-none');
                    }
                });
            } else {
                real.ajax.json(url + '/flags', {
                    type: 'POST',
                    complete: () => {
                        btn.html(btn.html().replace(btn.data('text-flag'), btn.data('text-unflag')));
                        btn.prop('disabled', false);
                        ownFlagBtn.removeClass('d-none');
                    }
                });
            }
        });

        // Vote button.
        widget.on('keydown', '.vote-btn', e => {
            const option = $(e.target);

            switch (e.key) {
                case 'ArrowDown':
                case 'ArrowRight':
                    e.preventDefault();
                    let nextOption = option.next('.vote-btn');
                    if (nextOption.length === 0) {
                        nextOption = option.closest('.vote-wrapper').find('.vote-btn').first();
                    }
                    nextOption.focus();
                    nextOption.click();
                    break;

                case 'ArrowUp':
                case 'ArrowLeft':
                    e.preventDefault();
                    let previousOption = option.prev('.vote-btn');
                    if (previousOption.length === 0) {
                        previousOption = option.closest('.vote-wrapper').find('.vote-btn').last();
                    }
                    previousOption.focus();
                    previousOption.click();
                    break;

                case ' ':
                    e.preventDefault();
                    option.click();
                    break;
            }
        });

        widget.on('click', '.vote-btn', e => {
            const btn = $(e.target);

            const comment = btn.closest('.comment');
            let url = howspace.widgets.getApiUrl(widget) + '/comment/' + comment.data('id');

            const voteBtns = comment.find('.vote-btn');
            voteBtns.prop('disabled', true);

            if (btn.is('.btn-primary')) {
                real.ajax.json(url + '/pointvote/' + btn.data('vote-id'), {
                    type: 'DELETE',
                    complete: () => {
                        voteBtns.prop('disabled', false);
                        btn[0].focus();
                    }
                });
            } else {
                const dataPayload = {
                    vote: btn.data('score')
                };
                if (btn.data('vote-id')) {
                    url += '/pointvote/' + btn.data('vote-id');
                } else {
                    url += '/pointvotes';
                }
                real.ajax.json(url, {
                    type: 'POST',
                    data: JSON.stringify(dataPayload),
                    complete: () => {
                        voteBtns.prop('disabled', false);
                        btn[0].focus();
                    }
                });
            }
        });

        // Bookmark button.
        widget.on('click', '.bookmark-btn', e => {
            const btn = $(e.target);
            btn.prop('disabled', true);

            if (btn.data('bookmark-id')) {
                real.ajax.json(real.baseUri + '/api/bookmark/' + btn.data('bookmark-id'), {
                    type: 'DELETE',
                    complete: () => {
                        btn.prop('disabled', false);
                        btn[0].focus();
                    }
                });
            } else {
                const comment = btn.closest('.comment');
                const reply = btn.closest('.reply');

                const dataPayload = {
                    widget: {
                        id: howspace.widgets.getId(widget),
                        type: howspace.widgets.getType(widget),
                    },
                    child: {
                        id: reply.length > 0 ? reply.data('id') : comment.data('id'),
                        type: reply.length > 0 ? 'reply' : 'comment'
                    }
                };

                real.ajax.json(real.baseUri + '/api/bookmarks', {
                    type: 'POST',
                    data: JSON.stringify(dataPayload),
                    complete: () => {
                        btn.prop('disabled', false);
                        btn[0].focus();
                    }
                });
            }
        });

        // Edit button.
        widget.on('click', '.edit-btn', e => {
            const btn = $(e.target);
            const parent = getParent(e);
            const editUrl = getCommentOrReplyUrl(btn, false) + '/edit';
            const loader = `<div class="howspace-loader howspace-lister-loader medium"></div>`;
            const editor = parent.find('.editor').first();
            const viewer = parent.find('.viewer').first();

            if (parent.is('.comment')) {
                parent.find('.comment-header-buttons').addClass('d-none');
            } else if (parent.is('.reply')) {
                parent.find('.reply-header-buttons').addClass('d-none');
            }

            viewer.addClass('d-none');
            // If parent is reply, then attach the reply input template
            editor.html(loader);
            real.ajax.html(editUrl, {
                type: 'GET',
                success: response => {
                    const editContent = $(response);
                    howspace.components.init(editContent);
                    editor.html(editContent);
                    editor.find('.comment-input, .reply-input').each(function() { syncDirBtn($(this)); });

                    if (parent.data('ai-assisted')) {
                        if (widget.data('is-sticky-notes')) {
                            editor.find('.badge-ai-assisted').removeClass('d-none');
                            editor.find('.badge-ai-assisted .close-ai-assist-btn').removeClass('d-none');
                        } else {
                            parent.find('.comment-content .header .badge-ai-assisted').removeClass('d-none');
                            parent.find('.comment-content .header .badge-ai-assisted .close-ai-assist-btn').removeClass('d-none');
                        }
                    }

                    howspace.animate(editor, 'slideDown', howspace.getAnimationDuration(widget, '--howspace-animation-350'), () => {
                        editor.removeAttr('style').removeClass('d-none');
                    });
                }
            });
            parent.find('.editor .save-btn').prop('disabled', false);
        });

        // Cancel edit button.
        widget.on('click', '.cancel-edit-btn', e => {
            const parent = getParent(e);
            const editor = parent.find('.howspace-simple-text-editor');

            if (parent.is('.comment')) {
                parent.find('.comment-header-buttons').removeClass('d-none');
            } else if (parent.is('.reply')) {
                parent.find('.reply-header-buttons').removeClass('d-none');
            }

            parent.find('.viewer').first().removeClass('d-none');
            parent.find('.editor').first().addClass('d-none').html('');
            parent.find('.editor .save-btn').prop('disabled', true);
            if (parent.data('ai-assisted')) {
                parent.find('.badge-ai-assisted').removeClass('d-none');
                parent.find('.badge-ai-assisted .close-ai-assist-btn').addClass('d-none');
            }
            if (editor.length > 0) {
                howspace.components.simpleTextEditor.clear(editor);
            }
        });

        // Save edit button.
        widget.on('click', '.save-btn', e => {
            const btn = $(e.target);
            const parent = getParent(e);
            const editor = parent.find('.editor');
            real.button.loading(btn, editor);
            const url = getCommentOrReplyUrl(btn);
            const dataPayload = real.form.getDataPayload(editor);
            if (howspace.widgets.getType(widget) === 'discussion' && parent.is('.comment')) {
                dataPayload.is_ai_assisted = parent.find('.badge-ai-assisted').is(':visible');
            }

            real.ajax.json(url, {
                type: 'POST',
                data: JSON.stringify(dataPayload),
                error: () => {
                    real.button.reset(btn, editor);
                }
            });
        });

        // Delete button.
        widget.on('click', '.delete-btn', e => {
            const btn = $(e.target);
            const url = getCommentOrReplyUrl(btn, false) + '/confirm-delete-modal';
            howspace.components.modal.show(url, (modal) => {
                modal = $(modal);
                modal.on('click', '.delete-btn', e => {
                    const confirmBtn = $(e.target);
                    real.button.loading(confirmBtn, modal);
                    real.ajax.json(getCommentOrReplyUrl(btn), {
                        type: 'DELETE',
                        complete: () => {
                            howspace.components.modal.close(modal[0]);
                        }
                    });
                });
            });
        });

        if (howspace.widgets.getType(widget) === 'discussion') {
            // Attach annotation image.
            widget.on('click', '.howspace-simple-text-editor', e => {
                const editor = $(e.target);
                const comment = editor.closest('.comment-input');
                const reply = editor.closest('.reply-input');
                let parent;

                if (reply.length > 0) {
                    parent = reply;
                } else if (comment.length > 0) {
                    parent = comment;
                }

                if (parent?.find('.attach-file-btn').length > 0) {
                    howspace.annotation.postAnnotation(widget, parent);
                }
            });

            // Annotation image click.
            widget.on('click', '.howspace-picture.annotation', e => {
                const picture = $(e.target).closest('.howspace-picture');
                howspace.annotation.showAnnotation(picture);
            });
        }

        if (howspace.widgets.getType(widget) === 'assignment') {
            // Attach AI feedback button.
            widget.on('click', '.feedback-btn', e => {
                const btn = $(e.target);
                const dataPayload = {
                    comment_id: btn.closest('.comment').data('id')
                };
                real.button.loading(btn);
                real.ajax.json(real.baseUri + '/api/ai/assignment/request-comment-feedback', {
                    type: 'POST',
                    data: JSON.stringify(dataPayload),
                    success: () => {
                        howspace.animate(btn, 'slideUp', howspace.getAnimationDuration(widget, '--howspace-animation-500'), () => {
                            btn.remove();
                        });
                    },
                    error: () => {
                        real.notification.show(howspace.translate('assignment_ai_feedback_failed'), 'error');
                        real.button.reset(btn);
                    }
                });
            });
        }

        widget.on('click', '.comment-time .time', e => {
            const btn = $(e.target).closest('.comment-time');
            btn.find('.time').toggleClass('d-none');
        });

        // Trigger click event if enter was pushed on the time element.
        widget.on('keydown', '.comment-time .time', e => {
            if (e.key === 'Enter') {
                $(e.target).click();
            }
        })

        widget.on('click', '.see-more-content-btn', e => {
            const btn = $(e.target);
            btn.closest('.viewer').find('.comment-text').removeClass('clamped-text');
            btn.addClass('d-none');
        });

        widget.on('paste', '.howspace-simple-text-editor.comment-text, .howspace-simple-text-editor.reply-text', e => {
            if (!e.originalEvent) {
                return;
            }
            if (e.originalEvent.clipboardData.items.length === 0) {
                return;
            }

            const editor = $(e.target).parent();
            const comment = editor.closest('.comment-input');
            const reply = editor.closest('.reply-input');
            let parent;
            if (reply.length > 0) {
                parent = reply;
            } else if (comment.length > 0) {
                parent = comment;
            }

            if (parent.find('.attach-file-btn').length > 0) {
                handleUploadedFileInEditor(e, widget, 'paste');
            }
        });

        widget.on('drop', '.howspace-simple-text-editor.comment-text, .howspace-simple-text-editor.reply-text', e => {
            e.preventDefault();
            if (!e.originalEvent) {
                return;
            }
            if (e.originalEvent.dataTransfer.files.length === 0) {
                return;
            }

            const editor = $(e.target).parent();
            const comment = editor.closest('.comment-input');
            const reply = editor.closest('.reply-input');
            let parent;
            if (reply.length > 0) {
                parent = reply;
            } else if (comment.length > 0) {
                parent = comment;
            }

            if (parent.find('.attach-file-btn').length > 0) {
                handleUploadedFileInEditor(e, widget, 'drop');
            }
        });

        widget.on('click', '.show-more-replies-btn', e => {
            const btn = $(e.target);
            btn.closest('.comment-hidden-replies-wrapper').addClass('d-none');
            const replies = btn.closest('.replies');
            const hiddenReplies = replies.find('.reply.d-none');

            hiddenReplies.removeClass('d-none');
            howspace.commentsTrait.clampCommentText(widget, hiddenReplies);
            howspace.animate(hiddenReplies, 'slideDown', howspace.getAnimationDuration(widget, '--howspace-animation-350'));
        });

        widget.on('click', '.show-all-comments-btn', () => {
            widget.removeDataAndAttr('limit-results-to-whats-new');
            widget.removeDataAndAttr('limit-results-to-comment-id');
            reloadComments(widget);
        });

        widget.on('click', '.close-ai-assist-btn', e => {
            const btn = $(e.currentTarget);
            const badge = btn.closest('.badge-ai-assisted');
            let parent = getParent(e);
            if (parent === undefined) {
                parent = btn.closest('.comment-input');
            }
            const editor = parent.find('.editor');
            editor.dataAndAttr('ai-assisted', false);
            badge.addClass('d-none');
        });

        widget.on(howspace.components.emojiPicker.EMOJI_PICKED, e => {
            const btn = $(e.target);
            let parent;

            if (btn.closest('.comment-input').length > 0) {
                parent = btn.closest('.comment-input');
            } else if (btn.closest('.reply-input').length > 0) {
                parent = btn.closest('.reply-input');
            } else if (btn.closest('.comment-buttons').length > 0) {
                parent = btn.closest('.comment-buttons');
            }

            if (!parent) {
                return;
            }

            const emoji = e.detail.emoji;

            // If the emoji picker is opened in a comment or reply, insert the emoji into the editor.
            if (parent.find('.howspace-simple-text-editor').length > 0) {
                const editor = parent.find('.howspace-simple-text-editor');

                howspace.components.simpleTextEditor.insertDataAtCursor(editor, emoji.native);
                howspace.components.simpleTextEditor.dispatchContentChanged(editor);
            }

            if (parent.find('.reaction-btn').length > 0) {
                if (!emoji?.id) {
                    return;
                }

                // If an emoji-button with data-reaction-id and data-included-current-user=true already exists then trigger a delete request to delete the reaction.
                // For example, if the user clicks on the :D emoji button, and the :D emoji is already selected,
                // and then select the :D emoji again in the picker, then the reaction should be deleted.
                const reactionBtn = parent.find('.emoji-button[data-included-current-user=true][data-reaction-id][data-emoji-id="' + emoji.id + '"]');
                if (reactionBtn.length > 0) {
                    handleDeletingReaction(reactionBtn);
                    return;
                }

                handleCreatingReaction(btn, emoji);
            }
        });

        widget.on('click', '.emoji-button[data-included-current-user="true"]', e => {
            const btn = $(e.target);
            handleDeletingReaction(btn);
        });

        widget.on('click', '.emoji-button:not([data-included-current-user="true"])', e => {
            const btn = $(e.target);
            const emojiId = btn.data('emoji-id');
            const emoji = btn.data('emoji');

            if (!emojiId || !emoji) {
                return;
            }
            handleCreatingReaction(btn, { id: emojiId.toString(), native: emoji });
        });

        // Supporting a long press on the button to open the users who have reacted modal on mobile
        let touchTimer;
        widget.on('touchstart', '.emoji-button', e => {
            const btn = $(e.target);
            const emojiId = btn.data('emoji-id');

            if (!emojiId) {
                return;
            }

            if (widget.data('is-permanently-anonymous')) {
                return;
            }

            const encodedEmojiId = encodeURIComponent(emojiId);

            touchTimer = setTimeout(() => {
                const url = getCommentOrReplyUrl($(e.target), false);
                howspace.components.modal.show(`${url}/users-who-have-reacted-modal?emoji_id=${encodedEmojiId}`, (modal) => {
                    modal = $(modal);
                    const emojiId = modal.data('emoji-id')

                    if (!emojiId) {
                        return;
                    }

                    const searchResults = (emojis) => {
                        const emoji = emojis?.[0]?.skins?.[0]; // Get the first skin variant of the emoji, usually the default one
                        if (emoji) {
                            modal.find('.modal-title').text(howspace.translate('discussion_users_who_reacted_with_emoji', { emoji: emoji.native }));
                        }
                    }

                    // Have to use the emojiId as a string because the emojiId like -1 will be converted to a number and the search will not work.
                    howspace.components.emojiPicker.searchEmoji(emojiId.toString(), 1, searchResults);
                });
            }, 500);
        });

        widget.on('touchend touchcancel', '.emoji-button', () => {
            clearTimeout(touchTimer);
        });

        widget.on('click', '.mention-btn', e => {
            const btn = $(e.target);

            let containerInput;
            if (btn.closest('.comment-input').length > 0) {
                containerInput = btn.closest('.comment-input');
            } else if (btn.closest('.reply-input').length > 0) {
                containerInput = btn.closest('.reply-input');
            }

            const editor = containerInput.find('.howspace-simple-text-editor');
            howspace.components.simpleTextEditor.insertDataAtCursor(editor, ' @');
        });

        // Keyboard activation is converted to a click by the global keydown handler in howspace.js.
        widget.find('.comment-category .toggle-btn').on('click', e => {
            const category = $(e.target).closest('.comment-category');
            setUncategorizedCommentsCollapsed(category, !category.hasClass('collapsed'));
        });

        widget.on('click', '.comment-category.collapsed', e => {
            if ($(e.target).closest('.toggle-btn').length > 0) {
                return;
            }
            setUncategorizedCommentsCollapsed($(e.currentTarget), false);
        });

        widget.on('click', '.ai-categorize-btn', e => {
            const btn = $(e.target);
            btn.closest('.ai-categorize-container').html('<div class="howspace-loader small"></div>');

            const dataPayload = {
                context: {
                    'widget_type': widget.data('widget-type'),
                    'widget_id': widget.data('widget-id')
                }
            };

            real.ajax.json(real.baseUri + '/api/ai/prompt/categorize-comments', {
                type: 'POST',
                data: JSON.stringify(dataPayload),
                error: () => {
                    real.notification.show(howspace.translate('discussion_ai_categorize_failed'), 'danger');
                }
            });
        });

        if (howspace.isMobile()) {
            widget.find('.mobile-attach-file-label').removeClass('d-none');
            widget.find('.attach-file-btn').addClass('d-none');

            widget.on('change', '.mobile-attach-file-input', e => {
                const modalOpener = $(e.target);
                const files = e.target.files;

                const url = `${real.baseUri}/modal/file-upload-modal?multiple=true&type=all`;
                howspace.components.modal.show(url, (modal) => {
                    modal = $(modal);

                    modal.find('.howspace-file-uploader-form').addClass('d-none');

                    modal.on(howspace.components.fileUploader.UPLOAD_COMPLETED, e => {
                        howspace.commentsTrait.attachmentHandlers.handleFileUploadCompleted(modal, modalOpener, e.detail.uploadedFiles);
                    });

                    const fileUploader = modal.find('.howspace-file-uploader');
                    howspace.components.fileUploader.startFileUploads(fileUploader[0], files);
                });
            });

            widget.on('click', '.mobile-attach-file-btn', e => {
                const btn = $(e.target);
                const parent = btn.closest('.action-buttons');
                parent.find('.mobile-attach-file-input').trigger('click');
            });
        }
    };

    const destroyComponentHandlers = widget => {
        howspace.commentsTrait.moveComment.destroy(widget);

        if (widget.hasClass('observing-resize')) {
            widget.removeData('latest-width');
            widget.removeClass('observing-resize');
            resizeObserver.unobserve(widget[0]);
        }
    };

    const updateNumberOfComments = (widget, diff) => {
        const newCount = Math.max(0, widget.data('number-of-comments') + diff);
        widget.dataAndAttr('number-of-comments', newCount);
        const textTranslation = howspace.widgets.getType(widget) === 'discussion'
            ? howspace.translate('discussion_number_of_comments', { count: newCount })
            : howspace.translate('assignment_number_of_answers', { count: newCount });

        widget.find('.widget-title .comments-count').text(`(${textTranslation})`);
    };

    const updateOrderNumber = (comment, orderNumber, incrementOrders) => {
        comment.dataAndAttr('order', orderNumber);
        if (incrementOrders) {
            comment.nextAll('article.comment').each((_i, nextComment) => {
                nextComment = $(nextComment);
                nextComment.dataAndAttr('order', nextComment.data('order') + 1);
            });
        }
    };

    const getCommentViewUrl = (widget, commentId) => {
        return howspace.widgets.getUrl(widget) + '/comment/' + commentId + '/view';
    };

    const getReplyViewUrl = (widget, commentId, replyId) => {
        return howspace.widgets.getUrl(widget) + '/comment/' + commentId + '/reply/' + replyId + '/view';
    };

    const attachEventHandlers = widgetType => {
        // Comment created event.
        howspace.widgets.onEvent(widgetType + ':comment:created', (widget, notification) => {
            let lister;
            if (widget.data('is-categorized')) {
                if (notification.object.comment.category?.id) {
                    lister = widget.find('.comments.howspace-lister[data-category-id=' + notification.object.comment.category.id + ']');
                } else {
                    lister = widget.find('.comments.howspace-lister:not([data-category-id])');
                }
                howspace.components.lister.updateItemsCount(lister, 1);
                checkUncategorizedComments(widget);
            } else {
                lister = widget.find('.comments.howspace-lister');
            }

            if (widget.find('.comment[data-id="' + notification.object.comment.id + '"]').length > 0) {
                // Comment is already on display
                return;
            }

            // This check is necessary because the backend cannot determine if the user is "view as participant" mode.
            // This is session-based, and only the frontend knows the user's view mode.
            // We cannot selectively send this notification in the backend, and it would prevent the expected
            // "what's new" notifications for the regular admin view.
            if (
                widgetType === 'assignment' &&
                $('.view-as-admin-btn').is(':visible') &&
                notification.actor.user.id !== real.dom.$body.data('user-id')
            ) {
                return;
            }

            updateNumberOfComments(widget, 1);

            checkPromptBtn(widget);

            if (real.events.isFromCurrentUser(notification)) {
                howspace.workspace.page.pathMode.handleUserHasInteracted(widget);
            }

            // If the current widget is a discussion widget, and the current user has just commented, and the
            // "Others' comments after commenting" option is enabled, then reload the lister.
            if (
                widgetType === 'discussion' &&
                real.events.isFromCurrentUser(notification) &&
                !widget.data('has-user-commented') &&
                !widget.data('user-can-see-comments-before-has-given-comment') &&
                (!widget.data('is-moderation-in-use') || notification.object.comment.is_approved)
            ) {
                widget.dataAndAttr('has-user-commented', true);
                lister.dataAndAttr('uri', lister.data('url'));
                howspace.components.lister.reload(lister);
                howspace.whatsNew.destroy(lister);
            } else {
                const renderComment = html => {
                    const newComment = $(html);
                    newComment.addClass('d-none');

                    const comments = lister.find('.howspace-lister-cards').first();
                    comments.css({ display: '', opacity: '' });

                    // If the "Show views" option is enabled, and the current user has viewed the comment,
                    // and the comment has no views, then update the views count.
                    if (widget.data('are-views-shown')
                        && newComment.find('.comment-buttons .show-views-btn').data('count') === 0) {
                        updateViews(notification, newComment);
                    }

                    if (widget.data('latest-comment-at-top')) {
                        comments.prepend(newComment);
                    } else {
                        comments.append(newComment);
                    }

                    // Show first comment if no comments were visible before.
                    if (lister.hasClass('no-items')) {
                        lister.removeClass('loading').removeClass('no-items').show();
                    }

                    howspace.animate(newComment, 'slideDown', howspace.getAnimationDuration(widget, '--howspace-animation-350'));

                    howspace.components.init(newComment);
                    howspace.whatsNew.decorateComment(newComment);
                    howspace.commentsTrait.clampCommentText(widget, newComment);
                    howspace.commentsTrait.commentsViewHandler.observeViews(widget);
                    if (widget.data('is-categorized')) {
                        updateOrderNumber(newComment, newComment.data('order'), notification.object.increment_orders);
                    }
                };

                if (howspace.widgets.isParallel(widget)) {
                    // fetch comment html with ajax so it will use the parallel settings
                    real.ajax.html(getCommentViewUrl(widget, notification.object.comment.id), {
                        success: renderComment
                    });
                } else {
                    renderComment(notification.object.comment.html);
                }
            }
        });

        // Reply created event.
        onCommentEvent(widgetType, 'reply:created', (notification, comment) => {
            const widget = comment.closest('.widget');

            const renderReply = html => {
                const newReply = $(html);
                const replies = comment.find('.replies');
                replies.removeClass('d-none');
                newReply.addClass('d-none');

                const replyInput = comment.find('.replies .reply-input');
                if (replyInput.length > 0) {
                    replyInput.before(newReply);
                } else {
                    replies.append(newReply);
                }

                howspace.animate(newReply, 'slideDown', howspace.getAnimationDuration(newReply, '--howspace-animation-350'));
                updateReplyCount(comment);

                // If the "Show views" option is enabled, and the current user has viewed the comment,
                // and the comment has no views, then update the views count.
                if (widget.data('are-views-shown') && newReply.find('.comment-buttons .show-views-btn').data('count') === 0) {
                    updateViews(notification, newReply);
                }

                howspace.components.init(newReply);
                howspace.whatsNew.decorateReply(newReply);
                howspace.commentsTrait.clampCommentText(widget, newReply);
                howspace.commentsTrait.commentsViewHandler.observeViews(comment.closest('.widget'));
            };

            if (howspace.widgets.isParallel(widget)) {
                // fetch reply html with ajax so it will use the parallel settings
                real.ajax.html(howspace.widgets.getUrl(widget) + '/comment/' + notification.object.comment.id + '/reply/' + notification.object.reply.id + '/view', {
                    success: renderReply
                });
            } else {
                renderReply(notification.object.reply.html);
            }
        });

        // Comment updated event.
        onCommentEvent(widgetType, 'updated', (notification, comment) => {
            const widget = comment.closest('.widget');
            const lister = comment.closest('.howspace-lister');

            if (widget.data('is-categorized') && notification.object.changed_properties.category) {
                // Widget is categorized and the category has changed, a dedicated comment categorized event will handle this.
                return;
            }

            const renderUpdatedComment = (html) => {
                howspace.components.destroy(comment);
                howspace.whatsNew.destroy(comment);

                const newComment = $(html);
                comment.replaceWith(newComment);
                howspace.components.init(newComment);
                howspace.whatsNew.decorateComment(newComment);
                howspace.commentsTrait.clampCommentText(widget, newComment);
                howspace.commentsTrait.commentsViewHandler.observeViews(widget);
            };

            // If the "Others' comments after commenting" option is enabled
            // and the current user has given a comment, and the comment of current user has just approved,
            // then reload the lister.
            if (widgetType === 'discussion' && notification?.object?.comment?.user?.id === real.dom.$body.data('user-id')
                && !widget.data('has-user-commented')
                && !widget.data('user-can-see-comments-before-has-given-comment')
                && (!widget.data('is-moderation-in-use') || notification.object.comment.is_approved)) {
                widget.dataAndAttr('has-user-commented', true);
                lister.dataAndAttr('uri', lister.data('url'));
                howspace.components.lister.reload(lister);
            } else if (howspace.widgets.isParallel(widget)) {
                // fetch comment html with ajax so it will use the parallel settings
                real.ajax.html(getCommentViewUrl(widget, notification.object.comment.id), {
                    success: renderUpdatedComment
                });
            } else {
                renderUpdatedComment(notification.object.comment.html);
            }
        });

        // Reply updated event.
        onReplyEvent(widgetType, 'updated', (notification, oldReply) => {
            const widget = oldReply.closest('.widget');

            const renderUpdatedReply = (html) => {
                howspace.components.destroy(oldReply);
                howspace.whatsNew.destroy(oldReply);

                const newReply = $(html);
                oldReply.replaceWith(newReply);
                howspace.components.init(newReply);
                howspace.whatsNew.decorateReply(newReply);
                howspace.commentsTrait.clampCommentText(widget, newReply);
            };

            if (howspace.widgets.isParallel(widget)) {
                // fetch comment html with ajax so it will use the parallel settings
                real.ajax.html(getReplyViewUrl(widget, notification.object.comment.id, notification.object.reply.id), {
                    success: renderUpdatedReply
                });
            } else {
                renderUpdatedReply(notification.object.reply.html);
            }
        });

        // Comment deleted event.
        onCommentEvent(widgetType, 'deleted', (n, comment) => {
            const widget = comment.closest('.widget');
            const lister = comment.closest('.comments.howspace-lister');

            if (widget.data('is-sticky-notes') || widget.data('is-categorized')) {
                howspace.components.lister.updateItemsCount(lister, -1);
            }

            updateNumberOfComments(widget, -1);

            checkPromptBtn(widget);

            howspace.animate(comment, 'slideUp', howspace.getAnimationDuration(comment, '--howspace-animation-350'), () => {
                comment.remove();
                if (widget.data('is-categorized')) {
                    checkUncategorizedComments(widget);
                }
                // If the "Others' comments after commenting" option is enabled, and there is no author's comments available,
                if (
                    widgetType === 'discussion' &&
                    !widget.data('user-can-see-comments-before-has-given-comment') &&
                    lister.find('.comment[data-author="1"').length === 0
                ) {
                    widget.dataAndAttr('has-user-commented', false);
                    lister.dataAndAttr('uri', '');
                    lister.find('.howspace-lister-cards').empty();
                }
            });
            howspace.components.destroy(comment);
            howspace.whatsNew.destroy(comment);
        });

        // Reply deleted event.
        onReplyEvent(widgetType, 'deleted', (n, reply) => {
            howspace.animate(reply, 'slideUp', howspace.getAnimationDuration(reply, '--howspace-animation-350'), () => {
                const comment = reply.closest('.comment');
                reply.remove();
                updateReplyCount(comment);
            });
            howspace.components.destroy(reply);
            howspace.whatsNew.destroy(reply);
        });

        // Like events.
        onCommentEvent(widgetType, 'like:created', (n, comment) => updateLikes(n, comment));
        onCommentEvent(widgetType, 'like:deleted', (n, comment) => updateLikes(n, comment, -1));
        onReplyEvent(widgetType, 'like:created', (n, reply) => updateLikes(n, reply));
        onReplyEvent(widgetType, 'like:deleted', (n, reply) => updateLikes(n, reply, -1));

        // View events.
        onCommentEvent(widgetType, 'view:created', (n, comment) => updateViews(n, comment));
        onReplyEvent(widgetType, 'view:created', (n, reply) => updateViews(n, reply));

        // Flag events.
        onCommentEvent(widgetType, 'flag:created', (n, comment) => updateFlags(n, comment));
        onCommentEvent(widgetType, 'flag:deleted', (n, comment) => updateFlags(n, comment, -1));
        onReplyEvent(widgetType, 'flag:created', (n, reply) => updateFlags(n, reply));
        onReplyEvent(widgetType, 'flag:deleted', (n, reply) => updateFlags(n, reply, -1));

        // Reactions events.
        onCommentEvent(widgetType, 'reaction:created', (n, comment) => updateReactions(n, comment));
        onCommentEvent(widgetType, 'reaction:deleted', (n, comment) => updateReactions(n, comment, -1));
        onReplyEvent(widgetType, 'reaction:created', (n, reply) => updateReactions(n, reply));
        onReplyEvent(widgetType, 'reaction:deleted', (n, reply) => updateReactions(n, reply, -1));

        // Voting events.
        onCommentEvent(widgetType, 'pointvote:created', (n, comment) => {
            if (real.events.isFromCurrentUser(n)) {
                const voteBtns = comment.find('.vote-btn');
                voteBtns.dataAndAttr('vote-id', n.object.pointvote.id);
                $(voteBtns[n.object.pointvote.vote - 1]).removeClass('btn-secondary').addClass('btn-primary').attr('aria-checked', true);
            }

            updateScore(comment, n.object.pointvote.vote);
        });

        onCommentEvent(widgetType, 'pointvote:updated', (n, comment) => {
            if (real.events.isFromCurrentUser(n)) {
                const voteBtns = comment.find('.vote-btn');
                voteBtns.dataAndAttr('vote-id', n.object.pointvote.id);
                voteBtns.removeClass('btn-primary').addClass('btn-secondary').attr('aria-checked', false);
                $(voteBtns[n.object.pointvote.new_vote - 1]).removeClass('btn-secondary').addClass('btn-primary').attr('aria-checked', true);
            }

            updateScore(comment, -n.object.pointvote.original_vote);
            updateScore(comment, n.object.pointvote.new_vote);
        });

        onCommentEvent(widgetType, 'pointvote:deleted', (n, comment) => {
            if (real.events.isFromCurrentUser(n)) {
                const voteBtns = comment.find('.vote-btn');
                voteBtns.removeDataAndAttr('vote-id');
                voteBtns.removeClass('btn-primary').addClass('btn-secondary').attr('aria-checked', false);
            }

            updateScore(comment, -n.object.pointvote.vote);
        });

        // Bookmark events.
        howspace.widgets.onEvent('widget:bookmark:created', (widget, notification) => {
            let article;
            if (notification.object.comment?.id) {
                article = widget.find('.comment[data-id="' + notification.object.comment.id + '"]');
            }
            if (notification.object.reply?.id) {
                article = widget.find('.reply[data-id="' + notification.object.reply.id + '"]');
            }
            if (article && article.length > 0) {
                const bookmarkBtn = article.find('.bookmark-btn').first();
                bookmarkBtn.dataAndAttr('bookmark-id', notification.object.bookmark.id);
            }
        });

        howspace.widgets.onEvent('widget:bookmark:deleted', (widget, notification) => {
            let article;
            if (notification.object.comment?.id) {
                article = widget.find('.comment[data-id="' + notification.object.comment.id + '"]');
            }
            if (notification.object.reply?.id) {
                article = widget.find('.reply[data-id="' + notification.object.reply.id + '"]');
            }
            if (article && article.length > 0) {
                const bookmarkBtn = article.find('.bookmark-btn').first();
                bookmarkBtn.removeDataAndAttr('bookmark-id');
            }
        });

        if (widgetType === 'discussion') {
            // Annotation events.
            howspace.widgets.onEvent('uploadedfile:annotation:created', (widget, notification) => {
                const token = notification.object.uploadedfile?.upload_process_metadata?.token;
                const parentContainer = widget.find('div[data-upload-token="' + token + '"]');
                howspace.components.progress.update(widget.find('.upload-progress'), 100, () => {
                    howspace.commentsTrait.attachmentHandlers.addAttachment(widget, parentContainer, notification.object.uploadedfile, true);
                    // Add a small delay to let the user see the progress bar at 100% :D
                    setTimeout(() => {
                        widget.find('.upload-progress').addClass('d-none');
                        howspace.components.progress.reset(widget.find('.upload-progress'));
                    }, 500);
                });

                parentContainer.removeDataAndAttr('upload-token');
                parentContainer.find('.send-btn').prop('disabled', false);
            });

            // Move comment event.
            howspace.widgets.onEvent('discussion:comment:moved', (widget, notification) => {
                howspace.commentsTrait.oldMoveCommentHandlers.moveComment(notification);
            });

            howspace.widgets.onEvent('discussion:comment:categorized', (widget, notification) => {
                const animDuration = 700;
                let comment = widget.find('article.comment[data-id="' + notification.object.comment_id + '"]');

                if (howspace.commentsTrait.moveComment.isDraggingComment(comment)) {
                    howspace.commentsTrait.moveComment.cancelDrag();
                }

                const fromCategory = getCategory(widget, notification.object.from_category_id);
                const toCategory = getCategory(widget, notification.object.to_category_id);

                // Update the selected category button (if there are any).
                comment.find('.category-btn.selected').removeClass('selected');
                comment.find('.category-btn[data-category-id="' + notification.object.to_category_id + '"]').addClass('selected');

                const toCards = toCategory.find('.howspace-lister-cards');
                // Just in case there are multiple comments with the same order number, we only care about the first one.
                const previousComment = toCards.find('article.comment[data-order="' + (notification.object.to_order_number - 1) + '"]').first();
                const nextComment = previousComment.next('.comment');

                if (comment.length === 0 && previousComment.length === 0 && notification.object.to_order_number > 1) {
                    // Neither comment nor previous comment is on display and not moving to the top of the category.
                    // So moving comments somewhere behind "show more", no need to do anything.
                    return;
                }

                const updateCategoryNumbers = () => {
                    howspace.components.lister.updateItemsCount(fromCategory.find('.howspace-lister.comments'), -1);
                    howspace.components.lister.updateItemsCount(toCategory.find('.howspace-lister.comments'), 1);
                };

                const readyCallback = () => {
                    updateOrderNumber(comment, notification.object.to_order_number, notification.object.increment_orders);
                    updateShowMoreButtons(widget, fromCategory, toCategory);

                    // Re-initialize comment after moving to avoid random issues such as empty emoji picker.
                    howspace.components.destroy(comment);
                    howspace.whatsNew.destroy(comment);
                    howspace.components.init(comment);
                    howspace.whatsNew.decorateComment(comment);
                    howspace.commentsTrait.clampCommentText(widget, comment);
                    howspace.commentsTrait.commentsViewHandler.observeViews(widget);
                }

                if (comment.length === 0) {
                    // Comment is not on display, fetch it with AJAX, append to correct position and slide down.
                    real.ajax.html(getCommentViewUrl(widget, notification.object.comment_id), {
                        success: (html) => {
                            if (previousComment.length > 0) {
                                previousComment.after(html);
                            } else {
                                toCards.prepend(html);
                            }
                            comment = toCards.find('article.comment[data-id="' + notification.object.comment_id + '"]');
                            howspace.animate(comment, 'slideDown', animDuration);
                            updateCategoryNumbers();
                            readyCallback();
                        }
                    });
                    return;
                }

                if (notification.object.to_order_number === 1) {
                    const firstComment = toCards.find('article.comment').first();
                    if (firstComment[0] === comment[0]) {
                        // Comment is already at the top of the category, just update the order number.
                        readyCallback();
                        return;
                    }
                }

                if (nextComment[0] === comment[0]) {
                    // Comment is already in the correct position, just update the order number.
                    readyCallback();
                    return;
                }

                updateCategoryNumbers();

                if (notification.object.to_order_number === 1) {
                    // Fly the comment from its original position to the top of the category.
                    makeCommentFly(widget, comment, animDuration, () => {
                        toCards.prepend(comment);
                        readyCallback();
                    });
                    return;
                }

                // Move comment after another comment in the category.
                if (previousComment.length > 0) {
                    // Fly the comment after the previous comment.
                    makeCommentFly(widget, comment, animDuration, () => {
                        previousComment.after(comment);
                        readyCallback();
                    });
                    return;
                }

                const removeComment = () => {
                    howspace.components.destroy(comment);
                    howspace.whatsNew.destroy(comment);
                    comment.remove();
                    updateShowMoreButtons(widget, fromCategory, toCategory);
                };

                const showMoreBtn = toCategory.find('.lister-load-more-btn');
                if (showMoreBtn.length === 0) {
                    removeComment();
                    return;
                }

                // Fly the comment to the show more button.
                makeCommentFly(widget, comment, animDuration, () => {
                    toCategory.find('.lister-load-more-btn').append(comment);
                }, removeComment);
            });
        }
    };

    const makeCommentFly = (widget, comment, animDuration, moveCommentCallback, animationDoneCallback) => {
        const commentCloneCss = {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
        };

        // Create a new placeholder that will fly over the screen.
        const flyPlaceholder = $('<div/>');
        flyPlaceholder.css({
            position: 'fixed',
            top: comment.offset().top - widget.offset().top,
            left: comment.offset().left - widget.offset().left,
            width: comment.width(),
            height: comment.height(),
            zIndex: 1000,
            overflow: 'hidden',
        });

        // Append a clone of the comment with source category styles into the fly placeholder.
        const fromCategoryId = comment.closest('.comment-category').data('category-id');
        const fromCommentClone = comment.clone();
        fromCommentClone.find('[id]').removeAttr('id');
        fromCommentClone.removeDataAndAttr('id');
        fromCommentClone.addClass('from-duplicate');
        fromCommentClone.css(commentCloneCss);
        const fromComputedStyle = getComputedStyle(comment[0]);
        fromCommentClone.css({
            '--howspace-comment-bg-color': fromComputedStyle.getPropertyValue('--howspace-comment-bg-color'),
            '--howspace-comment-text-color': fromComputedStyle.getPropertyValue('--howspace-comment-text-color'),
        });
        flyPlaceholder.append(fromCommentClone);

        // Animate a "from size" placeholder.
        const fromSizePlaceholder = $('<div/>');
        fromSizePlaceholder.css({
            width: comment.width(),
            height: comment.height(),
        });
        comment.after(fromSizePlaceholder);
        howspace.animate(fromSizePlaceholder, 'slideUp', animDuration);

        // Move the comment to another place in DOM.
        moveCommentCallback();

        // Append a clone of the comment with target category styles into the fly placeholder, but hide it initially.
        const toCategoryId = comment.closest('.comment-category').data('category-id');
        const toCommentClone = comment.clone();
        toCommentClone.find('[id]').removeAttr('id');
        toCommentClone.removeDataAndAttr('id');
        toCommentClone.addClass('to-duplicate');
        toCommentClone.css(commentCloneCss);
        const toComputedStyle = getComputedStyle(comment[0]);
        toCommentClone.css({
            '--howspace-comment-bg-color': toComputedStyle.getPropertyValue('--howspace-comment-bg-color'),
            '--howspace-comment-text-color': toComputedStyle.getPropertyValue('--howspace-comment-text-color'),
            opacity: 0,
        });
        flyPlaceholder.append(toCommentClone);

        // Animate a "to size" placeholder.
        const toSizePlaceholder = $('<div/>');
        comment.after(toSizePlaceholder);
        let flyToShowMore = false;
        if (comment.parent('.lister-load-more-btn').length > 0) {
            // We are flying to "show more button".
            flyToShowMore = true;
            toSizePlaceholder.css('position', 'absolute');
        } else {
            // We are flying to some category.
            howspace.animate(toSizePlaceholder, {
                width: comment.width(),
                height: comment.height() + 16, // Add 1rem unit of height to match the grid cap.
            },  animDuration);
        }

        // Append the fly placeholder to the widget.
        widget.append(flyPlaceholder);

        // Hide the comment for the duration of the animation.
        comment.addClass('d-none');

        // Fade out the source copy and fade in the target copy in the fly placeholder.
        howspace.animate(fromCommentClone, 'fadeOut', animDuration);
        howspace.animate(toCommentClone, 'fadeIn', animDuration);

        // Animate the fly placeholder to the new position.
        const animProps = {
            top: toSizePlaceholder.offset().top - widget.offset().top,
            left: toSizePlaceholder.offset().left - widget.offset().left,
        }
        if (fromCategoryId === toCategoryId && toSizePlaceholder.offset().top > flyPlaceholder.offset().top) {
            // When moving downwards within the same category we need to subtract the comment height
            // from the top value so that the comment doesn't fly too low.
            animProps.top -= comment.height();
        }
        let flyToCollapsedUncategorized = false;
        if (toSizePlaceholder.closest('.comment-category.uncategorized.collapsed').length > 0) {
            // Fly to collapsed uncategorized.
            flyToCollapsedUncategorized = true;
            const uncategorized = widget.find('.comment-category.uncategorized');
            animProps.top = uncategorized.offset().top - widget.offset().top + 16;
            animProps.left = uncategorized.offset().left - widget.offset().left;
        }
        if (flyToShowMore || flyToCollapsedUncategorized) {
            animProps.width = 0;
            animProps.height = 0;
        }
        howspace.animate(flyPlaceholder, animProps, animDuration, () => {
            // Animation complete, remove the fly placeholder and size placeholders and show the comment.
            flyPlaceholder.remove();
            fromSizePlaceholder.remove();
            toSizePlaceholder.remove();
            comment.removeClass('d-none');
            if (typeof animationDoneCallback === 'function') {
                animationDoneCallback();
            }
        });
    };

    const updateShowMoreButtons = (widget, fromCategory, toCategory) => {
        const fromCommentsLister = fromCategory.find('.comments.howspace-lister');
        const fromLoadMoreBtn = fromCommentsLister.find('.lister-load-more-btn');
        const fromComments = fromCommentsLister.find('.howspace-lister-cards .comment');
        if (fromComments.length >= fromCommentsLister.data('total-items')) {
            fromLoadMoreBtn.addClass('d-none');
        } else {
            const nextPageHref = fromLoadMoreBtn.data('next-items-page-href');
            if (nextPageHref !== undefined && nextPageHref.includes('offset=')) {
                const lastCommentId = fromComments.last().data('id') || null;
                const offsetStr = lastCommentId !== null ? 'offset=' + lastCommentId : '';
                const updatedHref = nextPageHref.replace(/offset=[a-f\d]{24}/, offsetStr);
                fromLoadMoreBtn.dataAndAttr('next-items-page-href', updatedHref);
            }
        }

        const toCommentsLister = toCategory.find('.comments.howspace-lister');
        const toLoadMoreBtn = toCommentsLister.find('.lister-load-more-btn');
        const toComments = toCommentsLister.find('.howspace-lister-cards .comment');
        if (toComments.length >= toCommentsLister.data('total-items')) {
            toLoadMoreBtn.addClass('d-none');
        } else {
            const nextPageHref = toLoadMoreBtn.data('next-items-page-href');
            if (nextPageHref !== undefined && nextPageHref.includes('offset=')) {
                const lastCommentId = toComments.last().data('id') || null;
                const offsetStr = lastCommentId !== null ? 'offset=' + lastCommentId : '';
                const updatedHref = nextPageHref.replace(/offset=[a-f\d]{24}/, offsetStr);
                toLoadMoreBtn.dataAndAttr('next-items-page-href', updatedHref);
            }
        }

        checkUncategorizedComments(widget);
    };

    const checkUncategorizedComments = (widget) => {
        const uncategorizedCategory = widget.find('.comment-category.uncategorized');
        const uncategorizedLister = uncategorizedCategory.find('.comments.howspace-lister');
        const uncategorizedCommentsCount = uncategorizedLister.data('total-items') || 0;
        const previousCommentsCount = uncategorizedCategory.data('previous-comments-count');

        uncategorizedCategory.data('previous-comments-count', uncategorizedCommentsCount);

        if (uncategorizedCommentsCount > 0) {
            uncategorizedCategory.find('.ai-categorize-container').removeClass('d-none');
        } else {
            uncategorizedCategory.find('.ai-categorize-container').addClass('d-none');
        }

        if (uncategorizedCommentsCount === previousCommentsCount) {
            return;
        }

        const shouldCollapse = uncategorizedCommentsCount === 0
            && (previousCommentsCount === undefined || previousCommentsCount > 0);
        const shouldExpand = uncategorizedCommentsCount > 0
            && (previousCommentsCount === undefined || previousCommentsCount === 0);

        if (shouldCollapse && !uncategorizedCategory.hasClass('collapsed')) {
            setUncategorizedCommentsCollapsed(uncategorizedCategory, true);
        } else if (shouldExpand && uncategorizedCategory.hasClass('collapsed')) {
            setUncategorizedCommentsCollapsed(uncategorizedCategory, false);
        }
    };

    const getCategory = (widget, categoryId) => {
        if (categoryId === null) {
            return widget.find('.comment-category.uncategorized');
        }
        return widget.find('.comment-category[data-category-id="' + categoryId + '"]');
    };

    const reloadComments = (widget) => {
        if (!(widget instanceof jQuery)) {
            widget = $(widget);
        }
        howspace.components.lister.reload(widget.find('.comments.howspace-lister'));
    }

    return {
        initFileUploaderModal: initFileUploaderModal,
        attachComponentHandlers: attachComponentHandlers,
        attachEventHandlers: attachEventHandlers,
        reloadComments: reloadComments,
        getCommentOrReplyUrl: getCommentOrReplyUrl,
        updateNumberOfComments: updateNumberOfComments,
        destroyComponentHandlers: destroyComponentHandlers,
        getCommentViewUrl: getCommentViewUrl,
        checkUncategorizedComments: checkUncategorizedComments,
        getCategory: getCategory,
        setUncategorizedCommentsCollapsed: setUncategorizedCommentsCollapsed,
    };
})();
